import React, { useState, useEffect } from 'react'
import { db } from "../../config/firebase"

const AllCommonData = () => {

   const [h, setH] = useState({})
   const [i, setI] = useState({})
   const [j, setJ] = useState({})

   useEffect(() => {
      db.collection("allCommon").get()
         .then((querySnapshot) => {
            setH(querySnapshot.docs[0].data())
            setI(querySnapshot.docs[1].data())
            setJ(querySnapshot.docs[2].data())
         })
         .catch(err => console.log(err))
      }, [])

   return (
      <>

         <div className="course-wrap course-h">
            <table>
               <thead>
                  <tr><th colSpan="1">H 演習授業</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>
                        {h.l1}<br/>
                        {h.l2}
                     </td>
                  </tr>
               </tbody>
            </table>
            <p className="desc">
               スマホ・タブレット・ノートパソコンを持参‣タブレットの貸し出し制度あります（演習授業時間帯のみ貸し出し、有料300円/月）<br/>
               できれば端末を持参ください。貸し出し(有料）もあります。端末なしの場合には教材付帯のドリル・確認テストなどを使います。<br/>
               個別指導・クラス授業・寺子屋だけでは演習・定着・暗記の学習の手段や時間の確保が難しく、理解したものを定着させるために令和３年より新設します。
            </p>
         </div>

         <div className="course-wrap course-i">
            <table>
               <thead>
                  <tr><th colSpan="2">I ウルトラ大逆転ゼミ（ウルゼミ）コース</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>ウルゼミのみ</td>
                     <td>{i.l1}</td>
                  </tr>
                  <tr>
                     <td>個別指導 + ウルゼミ</td>
                     <td>{i.l2}</td>
                  </tr>
               </tbody>
            </table>
            <p className="desc">
               生徒それぞれの性格や学力に合わせて個人カリキュラムを作成して適切な問題集・参考書を指示し指導します。<br/>
               個別対応指導＋学びエイド90分週1回です。（原則教えるのではなく自学自習のサポートをします。個別やクラスとの並行受講も可能です。）<br/>
               塾長（石田）が完全監督で学校の授業や教材を含めて指導し最適・最高の学習方法を伝授いたします。<br/>
               東進時代に石田が企画実施した奇跡のゼミ（愛称ウルゼミ）と言われ近隣の10数校の学力一桁の生徒を毎年輩出したゼミになります。<br/>
               1クラスは先着1０名で締め切ります。英語と中学数学の質問には応じられるます。5教科対応講師の場合には5教科質問対応可能です。<br/>
               曜日・時限　火・7限（20：20～21：50）＋　学びエイド週1回月・7限（20：20～21：50）<br/>
               ウルゼミには週1回の学びエイド授業が入ります。ウルゼミ＋学びエイドで週2回のコースになります。<br/>
               このコースでは生徒の学力に応じてテキスト・問題集・ドリル・参考書等を指示しますので別途教材費が掛かります。
            </p>
         </div>

         <div className="course-wrap course-j">
            <table>
               <thead>
                  <tr><th colSpan="2">J SSS（Self Study Support）コース</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>月謝</td>
                     <td>{j.l1}</td>
                  </tr>
                  <tr>
                     <td>教材費3科</td>
                     <td>{j.l2}</td>
                  </tr>
                  <tr>
                     <td>教材費5科</td>
                     <td>{j.l3}</td>
                  </tr>
                  <tr>
                     <td>独自校対策1教科（2教科）</td>
                     <td>{j.l4}</td>
                  </tr>
               </tbody>
            </table>
            <p className="desc">
               自宅での学習を支援・サポートするシステムです。週1回土曜日のみ塾に学習に来ることが可能になります。<br/>
               部活で忙しい中高生・費用負担を抑えて塾・予備校以上の授業を受けたい宅浪生に最適なコースです。<br/>
               東進ハイスクール28年勤務の塾長が勉強法・受験のことなど様々なアドヴァイスを受けることが出来ます。<br/>
               通信制と違い週に１回は通塾することが出来質問や相談に乗ってもらうことが可能です。
            </p>
         </div>
      </>
   )
}

export default AllCommonData